import { createFileRoute } from '@tanstack/react-router';

import { ChaptersAndScene } from '@/view/pages/ChaptersAndScene';

export const Route = createFileRoute('/_protected/$programId/capitulos-e-cenas')({
  component: ChaptersAndScene,
  context: (context): { title: string } => ({
    ...context,
    title: 'Capítulos e Cenas',
  }),
});
